export default __webpack_public_path__ + "static/media/MyCopa.28b556a2.png";